var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("footer", { staticClass: "lefebvre-footer-component" }, [
    _c("div", { staticClass: "info-wrapper" }, [
      _c("div", { staticClass: "information" }, [
        _c(
          "section",
          { staticClass: "logo-and-social-media" },
          [
            _c(_setup.LefebvreLogoComponent, { staticClass: "lefebvre-logo" }),
            _c(
              "ul",
              { staticClass: "social-media-list" },
              _vm._l(_setup.socialNetworkLinks, function (network, index) {
                return _c(
                  "li",
                  { key: `${index}-network`, staticClass: "network-item" },
                  [
                    _c(
                      "a",
                      {
                        staticClass: "network-link",
                        class: network.icon,
                        attrs: { href: network.url, target: "_blank" },
                      },
                      [
                        _c("img", {
                          attrs: { src: network.icon, alt: network.name },
                        }),
                        _c("span", { staticClass: "screen-reader-only" }, [
                          _vm._v(_vm._s(network.name)),
                        ]),
                      ]
                    ),
                  ]
                )
              }),
              0
            ),
          ],
          1
        ),
        _c("section", { staticClass: "text-container" }, [
          _c(
            "div",
            { staticClass: "policy-container" },
            [
              _c("p", { staticClass: "copyright" }, [
                _vm._v(
                  "© Lefebvre " +
                    _vm._s(_setup.currentYear) +
                    ". " +
                    _vm._s(_setup.texts.copyright)
                ),
              ]),
              _vm._l(_setup.footerLinks, function (link, index) {
                return [
                  _c(
                    "a",
                    {
                      key: `${index}-footer-link`,
                      staticClass: "footer-link",
                      attrs: { href: link.url, target: "_blank" },
                      on: {
                        click: function ($event) {
                          return _setup.handleLinkClick($event, link)
                        },
                      },
                    },
                    [_c("span", [_vm._v(_vm._s(_vm.$t(link.name)))])]
                  ),
                ]
              }),
            ],
            2
          ),
          _setup.lastAccess
            ? _c("div", { staticClass: "connection-container" }, [
                _vm._v(_vm._s(_setup.lastAccessText)),
              ])
            : _vm._e(),
        ]),
      ]),
    ]),
    _c("div", { staticClass: "border" }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }